import { render, staticRenderFns } from "./TrackDetails.vue?vue&type=template&id=0235ea0c&scoped=true"
import script from "./TrackDetails.vue?vue&type=script&lang=js"
export * from "./TrackDetails.vue?vue&type=script&lang=js"
import style0 from "./TrackDetails.vue?vue&type=style&index=0&id=0235ea0c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0235ea0c",
  null
  
)

export default component.exports